import {getUniqueSelector} from "VueApps/comments/services/highlight";

export const scrollToCommentId = (commentId) => {
    document
        .getElementById(getUniqueSelector(commentId))
        .scrollIntoView({
            block: "center",
            behavior: "smooth"
        });
};
